module.exports = __webpack_public_path__ + "img/nocvsearch.f68623c2.svg";